import React, { useEffect, forwardRef } from 'react';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import './mobile-editors-pick-style.scss';

import MobileProductListSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileProductListSkeleton';
import Button from '@src/componentsNew/Buttons/Button';
import ProductListTitle from '@src/componentsNew/ProductListTitle/ProductListTitle';
import SectionDivider from '@src/componentsNew/SectionDivider';
import MobileHorizontalProductThumbnail from '@src/componentsNew/ProductThumbnail/HorizontalProductThumbnail/MobileHorizontalProductThumbnail';

import ChevronRightIcon from '@src/componentsNew/Icons/Icons/ChevronRightIcon';

import { StockAvailability } from '__generated__/globalTypes';
import { HOMEPAGE_COLLECTION_ID } from './queries';
import { homepageCollectionID } from './__generated__/homepageCollectionID';
import { MOBILE_PRODUCT_LIST } from '@src/components/ProductPage/ProductList/queries';
import { mobileProducts } from '@components/ProductPage/ProductList/__generated__/mobileProducts';

import { makeCollectionUrl } from '@src/utils';
import { getDBIdFromGraphqlId } from '@src/core/utils';
import { getInvisibleProductIds } from '@src/utils/constants';
import { useInvisibleProductIds } from "@src/hooks/useInvisibleProductIds";

const MobileEditorsPick = forwardRef<HTMLDivElement>((_, ref) => {
  const ready = useInvisibleProductIds();
  const history = useHistory();

  const { data, loading } = useQuery<homepageCollectionID>(HOMEPAGE_COLLECTION_ID);

  const [
    getHomepageCollectionProducts,
    { data: homepageCollectionProducts, loading: homepageCollectionProductsLoading },
  ] = useLazyQuery<mobileProducts>(MOBILE_PRODUCT_LIST);

  useEffect(() => {
    if (!loading && data?.shop?.homepageCollection?.id) {
      getHomepageCollectionProducts({
        variables: {
          collections: [data.shop.homepageCollection.id],
          stockAvailability: StockAvailability.IN_STOCK,
          first: 6,
        },
      });
    }
  }, [data?.shop]);

  if (!ready || loading || homepageCollectionProductsLoading) {
    return (
      <MobileProductListSkeleton type="vertical" hasTitle={true} hasTitleRightArea={true} hasBottomDivider={true} />
    );
  }

  return homepageCollectionProducts?.products.totalCount > 0 ? (
    <div className="mobile-ediotrs-pick-wrapper" ref={ref}>
      <ProductListTitle
        title={data.shop.homepageCollection.name}
        typoVariant="h8"
        typoComponent="h4"
        url={makeCollectionUrl(
          data.shop.homepageCollection.slug,
          getDBIdFromGraphqlId(data?.shop.homepageCollection.id).toString(),
        )}
        isShowRightBtn={true}
        rightBtnText=""
        rightBtnColor="#666666"
        isShowArrow={true}
      />

      <div className="mobile-editors-pick-thumbnails-wrapper">
        {homepageCollectionProducts?.products?.edges
          .filter((edge) => {
            return !getInvisibleProductIds().includes(getDBIdFromGraphqlId(edge.node.id)?.toString());
          })
          .map((edge) => (
            <MobileHorizontalProductThumbnail key={edge.node.id} product={edge.node} />
          ))}
        <Button
          size="small"
          variant="text"
          style={{ color: '#F82296' }}
          endIcon={<ChevronRightIcon width="20" height="20" strokeColor="#F82296" />}
          onClick={() =>
            history.push(
              makeCollectionUrl(
                data.shop.homepageCollection.slug,
                getDBIdFromGraphqlId(data?.shop.homepageCollection.id).toString(),
              ),
            )
          }
        >
          See All
        </Button>
      </div>

      <SectionDivider style={{ marginTop: '24px' }} />
    </div>
  ) : null;
});

export default MobileEditorsPick;
